import {getData} from "../api/get-data";

export const getCart = ({resolveHandler}) => {
  getData({
    [`get_cart`]: ``
  })
  .then((response) => {
    resolveHandler(response);
  });
};
